import { Badge } from "@/components/ui/badge";
import { CircleNotch } from "@phosphor-icons/react";

export const SA_API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const SA_TOKEN_KEY = "caus_super_token";

export const saToken = () => sessionStorage.getItem(SA_TOKEN_KEY) || "";

export async function saFetch(path, options = {}) {
  const res = await fetch(`${SA_API}${path}`, {
    ...options,
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${saToken()}`, ...(options.headers || {}) },
  });
  if (res.status === 401) {
    sessionStorage.removeItem(SA_TOKEN_KEY);
    window.location.reload();
    throw new Error("Sesión expirada");
  }
  if (!res.ok) {
    let msg = `Error ${res.status}`;
    try {
      const d = await res.json();
      msg = typeof d.detail === "string" ? d.detail : msg;
    } catch { /* sin cuerpo */ }
    throw new Error(msg);
  }
  return res.json();
}

export const fmtMoney = (n, currency = "HNL") =>
  `${currency === "HNL" ? "L" : currency} ${Number(n || 0).toLocaleString("es-HN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtDate = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("es-HN", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return String(d);
  }
};

export const fmtDateTime = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleString("es-HN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return String(d);
  }
};

export function SAStat({ icon: Icon, label, value, hint, tone = "primary", testid }) {
  const tones = {
    primary: "bg-primary/15 text-primary",
    emerald: "bg-emerald-500/15 text-emerald-500",
    amber: "bg-amber-500/15 text-amber-500",
    red: "bg-red-500/15 text-red-500",
    sky: "bg-sky-500/15 text-sky-500",
    violet: "bg-violet-500/15 text-violet-400",
  };
  return (
    <div className="border border-border bg-card rounded-sm p-4 hover:border-primary/50 hover:-translate-y-0.5 transition-[border-color,transform] duration-200" data-testid={testid}>
      <div className="flex items-center justify-between">
        <span className="text-[11px] uppercase tracking-widest text-muted-foreground">{label}</span>
        {Icon && (
          <span className={`flex h-8 w-8 items-center justify-center rounded-md ${tones[tone]}`}>
            <Icon className="h-4 w-4" />
          </span>
        )}
      </div>
      <div className="mt-2 font-heading text-2xl font-semibold text-foreground">{value}</div>
      {hint && <div className="mt-0.5 text-xs text-muted-foreground">{hint}</div>}
    </div>
  );
}

const PAY_STATUS = {
  pending: "bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/25",
  approved: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/25",
  rejected: "bg-red-500/15 text-red-600 dark:text-red-400 border-red-500/25",
  cancelled: "bg-secondary text-muted-foreground border-border",
  refunded: "bg-sky-500/15 text-sky-600 dark:text-sky-400 border-sky-500/25",
};

const PAY_LABELS = { pending: "Pendiente", approved: "Aprobado", rejected: "Rechazado", cancelled: "Cancelado", refunded: "Reembolsado" };

export function PayBadge({ status }) {
  return (
    <Badge variant="outline" className={`rounded-sm font-normal ${PAY_STATUS[status] || "bg-secondary text-muted-foreground border-border"}`} data-testid={`pay-status-${status}`}>
      {PAY_LABELS[status] || status}
    </Badge>
  );
}

export function SALoading({ label = "Cargando..." }) {
  return (
    <div className="flex items-center gap-3 py-16 justify-center text-muted-foreground" data-testid="sa-loading">
      <CircleNotch className="h-5 w-5 animate-spin" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export const inputCls =
  "rounded-sm border-input bg-background text-foreground placeholder:text-muted-foreground focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-0";

export const btnOutline =
  "rounded-sm border-input bg-transparent text-foreground/80 hover:bg-accent hover:text-accent-foreground";

export const btnPrimary = "rounded-sm bg-primary text-primary-foreground hover:bg-primary/80";

export const FEATURE_LABELS = {
  empleados: "Empleados", turnos: "Turnos", horarios: "Horarios", asistencia: "Asistencia",
  planillas: "Planillas", solicitudes: "Solicitudes", documentos: "Documentos",
  notificaciones: "Notificaciones", reportes: "Reportes", vouchers_email: "Vouchers por correo",
  adjuntos: "Adjuntos", marca_personalizada: "Marca personalizada",
};
